// extracted by mini-css-extract-plugin
export default {"brand":"HeaderLogo_brand__kbmCJ","container":"HeaderLogo_container__tn7iP","logo":"HeaderLogo_logo__YPHJb","sublogo":"HeaderLogo_sublogo__0zjT8","link":"HeaderLogo_link__H8ANb"};